// A rejected request may have only optimistic local transcript rows. Retry
// those as a normal request while the UI reuses its existing local rows.
// Only a persisted assistant message can be regenerated on the server.
export const createResubmitPayload = (conversationId, messageId) => {
  if (!Number.isInteger(conversationId) || conversationId <= 0 ||
      !Number.isInteger(messageId) || messageId <= 0) return {};
  return { resubmit: true, resubmit_message_id: messageId };
};
